import { render, staticRenderFns } from "./WheelsTimeInput.vue?vue&type=template&id=9b479da6&scoped=true"
import script from "./WheelsTimeInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./WheelsTimeInput.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WheelsTimeInput.vue?vue&type=style&index=0&id=9b479da6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b479da6",
  null
  
)

export default component.exports